var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-around"},_vm._l(([0, 1, 2, 3]),function(i){return _c('div',{key:`indicator${i}`,staticClass:"indicator-light",class:{'valid': _vm.state >= i}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }